import requests from './httpService';
const ProfileRegistrationService = {
  getAllProfileRegistration() {
    return requests.get('/profileregistration/list');
  },
  creteProfileRegistration(body){
    return requests.post('/profileregistration/add',body); 
  },
  loginProfileRegistration(body){ 
    return requests.post('/profileregistration/login', body);
  },
  sendPasswordResetOTP(body) {
    return requests.post('/profileregistration/forgot-password/send-otp', body);
  },
  verifyPasswordResetOTP(body) {
    return requests.post('/profileregistration/forgot-password/verify-otp', body);
  },
  resetPasswordWithOTP(body) {
    return requests.post('/profileregistration/forgot-password/reset-password', body);
  }
};

export default ProfileRegistrationService;
